<template>
  <div class="toApp_box">
    <img class="toApp_img" src="../../../assets/img/toapp.png" alt="">
    <a href="javascript:;" class="toApp_btn" @click="$emit('clickClose')"></a>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {}
    }
  }
</script>

<style scoped>
  .toApp_box{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    position: absolute;
    top: 0;
    left: 0;
  }
  .toApp_img{
    width: 100%;
  }
  .toApp_btn{
     width: 277px;
     height: 50px;
     position: absolute;
     left: 49px;
     top: 407px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cdjs/children/toApp.vue